import * as React from 'react';
import { Box } from '@mui/material';

function CustomDivider({ sx }) {
  return <Box aria-hidden="true" sx={{ width: 64, height: 4, mb: 3, borderRadius: 99, background: 'linear-gradient(90deg,#9f1622,#d1545e)', ...sx }} />;
}

export default CustomDivider;
